import type { ReactNode } from 'react';
import React from 'react';
import { Card, Typography } from 'antd';

interface PageLayoutProps {
  title?: string;
  children: ReactNode;
}

/**
 * PageLayout provides a consistent layout for page content
 * with a title and wrapped in a card with consistent styling
 */
export const PageLayout: React.FC<PageLayoutProps> = ({ title, children }) => {
  return (
    <Card style={{ borderRadius: '8px' }}>
      {title && (
        <Typography.Title level={2} style={{ marginTop: 0, marginBottom: '24px' }}>
          {title}
        </Typography.Title>
      )}
      {children}
    </Card>
  );
};
